import React from 'react';
import { FILTER_COLLATION, FILTER_OPERATION, ModelRenderer } from '@veeam/core';
import { Search, SEARCH_MODE } from "../../controls";
import { COLLECTION_MODEL_FILTER_TYPES } from "../collectionModel/types";
var DEFAULT_SEARCH_DEBOUNCE_TIME = 250;
export function toolbarSearchFilter(_a) {
    var property = _a.property, _b = _a.operation, operation = _b === void 0 ? FILTER_OPERATION.contains : _b, _c = _a.collation, collation = _c === void 0 ? FILTER_COLLATION.ignorecase : _c, decorators = _a.decorators, disabled = _a.disabled, _d = _a.groupId, groupId = _d === void 0 ? '' : _d, fieldConfig = _a.fieldConfig;
    var _e = fieldConfig || {}, placeholder = _e.placeholder, maxLength = _e.maxLength, _f = _e.mode, mode = _f === void 0 ? SEARCH_MODE.automatic : _f, _g = _e.searchDebounceTimeInMs, searchDebounceTimeInMs = _g === void 0 ? DEFAULT_SEARCH_DEBOUNCE_TIME : _g, onChange = _e.onChange, size = _e.size;
    return {
        decorators: decorators,
        disabled: disabled,
        render: function (model, _a) {
            var disabled = _a.disabled;
            return (React.createElement(ModelRenderer, { model: model, render: function (_a) {
                    var value = _a.value;
                    return (React.createElement(Search, { value: String(value.filters.getFilterValue({ property: property, groupId: groupId }) || ''), size: size, mode: mode, placeholder: placeholder, maxLength: maxLength, searchDebounceTimeInMs: searchDebounceTimeInMs, onChange: onChange, disabled: disabled, onSearch: function (value) {
                            model.setFilter({ property: property, groupId: groupId }, value
                                ? {
                                    operation: operation,
                                    collation: collation,
                                    value: value,
                                    type: COLLECTION_MODEL_FILTER_TYPES.search
                                }
                                : null);
                        }, onClear: function () {
                            model.setFilter({ property: property, groupId: groupId }, null);
                        } }));
                } }));
        }
    };
}
//# sourceMappingURL=toolbarSearchFilter.js.map